// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2498":"e307bb9c","8428":"e307bb9c"}[chunkId] + ".chunk.css";
};